const books_data = [
  {
    id: 'ai-agents-in-action',
    title: 'AI Agents in Action',
    image: '/images/books/ai-agents-in-action.jpg',
    author: 'Micheal Lanham'
  },
  {
    id: 'team-topologies',
    title: 'Team Topologies',
    image: '/images/books/team-topologies.jpg',
    author: 'Matthew Skelton, Manuel Pais'
  },
  {
    id: 'architecture-modernization',
    title: 'Architecture Modernization',
    image: '/images/books/architecture-modernization.jpg',
    author: 'Nick Tune'
  },
  {
    id: 'no-rules-rules',
    title: 'No Rules Rules',
    image: '/images/books/no-rules-rules.jpg',
    author: 'Reed Hastings, Erin Meyer'
  },
  {
    id: 'the-art-of-readable-code',
    title: 'The Art of Readable Code',
    image: '/images/books/the-art-of-readable-code.jpg',
    author: 'Dustin Boswell, Trevor Foucher'
  },
  {
    id: 'designing-data-intensive-applications',
    title: 'Designing Data-Intensive Applications',
    image: '/images/books/designing-data-intensive-applications.jpg',
    author: 'Martin Kleppmann'
  },
  // {
  //   id: 'staff-engineers-path',
  //   title: 'The Staff Engineer`s Path',
  //   image: '/images/books/the-staff-engineers-path.jpg',
  //   author: 'Tanya Reilly'
  // },
  {
    id: 'tidy-first',
    title: 'Tidy First?',
    image: '/images/books/tidy-first.jpg',
    author: 'Kent Beck'
  },
  {
    id: 'ai-engineering',
    title: 'AI Engineering',
    image: '/images/books/ai-engineering.jpg',
    author: 'Chip Huyen'
  },
  {
    id: 'grokking-concurrency',
    title: 'Grokking Concurrency',
    image: '/images/books/grokking-concurrency.jpg',
    author: 'Kirill Bobrov'
  },
  {
    id: 'docs-for-developers',
    title: 'Docs for Developers',
    image: '/images/books/docs-for-developers.jpg',
    author: 'Jared Bhatti, Zachary Sarah'
  },
  {
    id: 'high-performance-postgresql-for-rails',
    title: 'High Performance PostgreSQL for Rails',
    image: '/images/books/high-performance-postgresql-for-rails.jpg',
    author: 'Andrew Atkinson'
  },
  {
    id: 'the-software-engineers-guidebook',
    title: 'The Software Engineer\'s Guidebook',
    image: '/images/books/the-software-engineers-guidebook.jpg',
    author: 'Gergely Orosz'
  },
  {
    id: 'escaping-the-build-trap',
    title: 'Escaping The Build Trap',
    image: '/images/books/escaping-the-build-trap.jpg',
    author: 'Melissa Perry',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'the-new-turing-omnibus',
    title: 'The New Turing Omnibus',
    image: '/images/books/the-new-turing-omnibus.jpg',
    author: 'A.K. Dewdney',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'understanding-distributed-systems',
    title: 'Understanding Distributed Systems',
    image: '/images/books/understanding-distributed-systems.jpg',
    author: 'Roberto Vitillo',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'radical-candor',
    title: 'Radical Candor',
    image: '/images/books/radical-candor.png',
    author: 'Kim Scott',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'the-culture-map',
    title: 'The Culture Map',
    image: '/images/books/the-culture-map.jpg',
    author: 'Erin Meyer',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'monolith-to-microservices',
    title: 'Monolith to Microservices',
    image: '/images/books/monolith-to-microservices.jpg',
    author: 'Sam Newman',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'guide-to-competitive-programming',
    title: 'Guide to Competitive Programming',
    image: '/images/books/guide-to-competitive-programming.jpg',
    author: 'Antti Laaksonen',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'engineering-management-for-the-rest-of-us',
    title: 'Engineering Management For The Rest Of Us',
    image: '/images/books/engineering-management-for-the-rest-of-us.jpg',
    author: 'Sarah Drasner',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'database-internals',
    title: 'Database Internals',
    image: '/images/books/database-internals.jpg',
    author: 'Alex Petrov',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'a-philosophy-of-software-design',
    title: 'A Philosophy Of Software Design',
    image: '/images/books/a-philosophy-of-software-design.jpg',
    author: 'John Ousterhout',
    categories: '#software-design #individual-contributor'
  },
  {
    id: 'system-design-interview',
    title: 'System Design Interview',
    image: '/images/books/system-design-interview.jpg',
    author: 'Alex Xu'
  },
];

export { books_data };
